import { TemplateScope } from '@principle-theorem/principle-core/interfaces';
import {
  ICanBeChartedProperty,
  IScopeDataAccessor,
  ScopeDataAccessorMap,
} from '@principle-theorem/reporting/interfaces';
import { AppointmentDimensionMeasures } from '../models/dimensions/appointment-dimension';
import { InvoiceDimensionMeasures } from '../models/dimensions/invoice-dimension';
import { PatientDimensionMeasures } from '../models/dimensions/patient-dimension';
import { TreatmentPlanDimensionMeasures } from '../models/dimensions/treatment-plan-dimension';

type ScopeMeasure =
  | PatientDimensionMeasures
  | AppointmentDimensionMeasures
  | InvoiceDimensionMeasures
  | TreatmentPlanDimensionMeasures;

export class ReportBuilderScopeDataAccessors {
  static build(measures: ScopeMeasure[]): ScopeDataAccessorMap {
    return measures.reduce((accessorMap: ScopeDataAccessorMap, measure) => {
      if (measure instanceof PatientDimensionMeasures) {
        accessorMap[TemplateScope.Patient] =
          ReportBuilderScopeDataAccessors.patient(measure);
      }
      if (measure instanceof AppointmentDimensionMeasures) {
        accessorMap[TemplateScope.Appointment] =
          ReportBuilderScopeDataAccessors.appointment(measure);
      }
      if (measure instanceof InvoiceDimensionMeasures) {
        accessorMap[TemplateScope.Invoice] =
          ReportBuilderScopeDataAccessors.invoice(measure);
      }
      if (measure instanceof TreatmentPlanDimensionMeasures) {
        accessorMap[TemplateScope.TreatmentPlan] =
          ReportBuilderScopeDataAccessors.treatmentPlan(measure);
      }
      return accessorMap;
    }, {});
  }

  static patient(measures: PatientDimensionMeasures): IScopeDataAccessor {
    return ReportBuilderScopeDataAccessors.accessor(
      measures.ref,
      measures.name
    );
  }

  static appointment(
    measures: AppointmentDimensionMeasures
  ): IScopeDataAccessor {
    return ReportBuilderScopeDataAccessors.accessor(
      measures.ref,
      measures.date
    );
  }

  static invoice(measures: InvoiceDimensionMeasures): IScopeDataAccessor {
    return ReportBuilderScopeDataAccessors.accessor(
      measures.ref,
      measures.reference
    );
  }
  static treatmentPlan(
    measures: TreatmentPlanDimensionMeasures
  ): IScopeDataAccessor {
    return ReportBuilderScopeDataAccessors.accessor(
      measures.ref,
      measures.name
    );
  }

  static accessor(
    scope: ICanBeChartedProperty,
    scopeLabel?: ICanBeChartedProperty
  ): IScopeDataAccessor {
    return {
      scopeMeasure: scope,
      scopeLabelMeasure: scopeLabel ?? scope,
    };
  }
}
